export default {

	init(element, data, option) {
		const baseSize = parseFloat(window.getComputedStyle(document.querySelector("html")).fontSize.replace("px", "")) / 10
		const style = window.getComputedStyle(element)
		const pTop = parseFloat(style.paddingTop.replace("px", ""))
		const pRight = parseFloat(style.paddingRight.replace("px", ""))
		const pBottom = parseFloat(style.paddingBottom.replace("px", ""))
		const pLeft = parseFloat(style.paddingLeft.replace("px", ""))
		const width = parseFloat(style.width.replace("px", "")) - pLeft - pRight
		const height = parseFloat(style.height.replace("px", "")) - pTop - pBottom

		if (!option) option = {}
		if (!option.padding) option.padding = "0 0 0 0"
		let paddings = option.padding?.toString().split(" ")
		paddings = paddings.map((item) => parseFloat(item))

		let paddingTop, paddingRight, paddingBottom, paddingLeft

		if (paddings.length === 1) paddingTop = paddingRight = paddingBottom = paddingLeft = paddings[0]
		if (paddings.length === 2) {
			paddingTop = paddingBottom = paddings[0]
			paddingRight = paddingLeft = paddings[1]
		}
		if (paddings.length === 3) {
			paddingTop = paddings[0]
			paddingRight = paddingLeft = paddings[1]
			paddingBottom = paddings[2]
		}
		if (paddings.length === 4) {
			paddingTop = paddings[0]
			paddingRight = paddings[1]
			paddingBottom = paddings[2]
			paddingLeft = paddings[3]
		}

		paddingTop = (option.paddingTop ?? paddingTop) * baseSize
		paddingRight = (option.paddingRight ?? paddingRight) * baseSize
		paddingBottom = (option.paddingBottom ?? paddingBottom) * baseSize
		paddingLeft = (option.paddingLeft ?? paddingLeft) * baseSize

		const graphWidth = width - paddingLeft - paddingRight
		const graphHeight = height - paddingTop - paddingBottom

		let max, totals = []

		data.forEach(d => {
			let total = 0
			const m = d.reduce((prev, item) => {
				if (prev.value) prev = parseFloat(prev.value)
				const now = parseFloat(item.value)
				total += Number(item.value)
				return prev > now ? prev : now
			}, 0)
			if (max === undefined) max = m
			max = m > max ? m : max
			totals.push(total)
		})

		const cap = max + max * 0.1

		return {
			baseSize,
			element,
			style,
			width,
			height,
			paddingTop,
			paddingRight,
			paddingBottom,
			paddingLeft,
			graphWidth,
			graphHeight,
			max,
			totals,
			cap
		}
	},

	SVG(tag, attrs) {
		var element = document.createElementNS('http://www.w3.org/2000/svg', tag);
		for (var key in attrs) {
			element.setAttribute(key, attrs[key]);
		}
		return element;
	},

	polarToCartesian(centerX, centerY, radius, angleInDegrees) {
		var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
		return {
			x: centerX + (radius * Math.cos(angleInRadians)),
			y: centerY + (radius * Math.sin(angleInRadians))
		};
	},

	describeArc(x, y, radius, startAngle, endAngle) {
		var start = this.polarToCartesian(x, y, radius, endAngle);
		var end = this.polarToCartesian(x, y, radius, startAngle);
		var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

		var d = [
			"M", start.x, start.y,
			"A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
		].join(" ");

		return d;
	},

	rotate(cx, cy, x, y, angle) {
		var radians = (Math.PI / 180) * angle,
			cos = Math.cos(radians),
			sin = Math.sin(radians),
			nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
			ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
		return [nx, ny];
	}
}